<template>
  <v-card light flat min-width="250">
    <v-img
      :src="`${filesUrl}/${profilePhoto.id}?access_token=${accessToken}`"
      height="100px"
      dark
      v-if="member && profilePhoto"
    >
      <v-row class="fill-height">
        <v-spacer></v-spacer>

        <v-card-title class="white--text">
          <div
            class="title"
          >{{member.first_name || member.contact && member.contact.first_name}} {{member.last_name || member.contact && member.contact.last_name}}</div>
        </v-card-title>
      </v-row>
    </v-img>
    <v-card-title v-if="member && !profilePhoto">
      <div
        class="title"
      >{{member.first_name || member.contact && member.contact.first_name}} {{member.last_name || member.contact && member.contact.last_name}}</div>
    </v-card-title>

    <v-card-text v-if="member">
      <v-list two-line>
        <v-list-item v-if="member.cell">
          <v-list-item-icon>
            <v-icon color="accent">mdi-phone</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{member.cell}}</v-list-item-title>
            <v-list-item-subtitle>Mobile</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-icon>
            <v-icon>mdi-message-text</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-divider inset v-if="member.email"></v-divider>

        <v-list-item v-if="member.email">
          <v-list-item-icon>
            <v-icon color="accent">mdi-at</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{member.email}}</v-list-item-title>
            <v-list-item-subtitle>Personal</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider inset v-if="member.physical_address"></v-divider>

        <v-list-item v-if="member.physical_address">
          <v-list-item-icon>
            <v-icon color="accent">mdi-map-marker</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{addressFirstLine}}</v-list-item-title>
            <v-list-item-subtitle>{{addressTheRest}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { makeGetMixin } from "feathers-vuex";

export default {
  data() {
    return {
      loading: false
    };
  },
  mixins: [
    makeGetMixin({ service: "members", name: "cardMember", id: "memberId" }),
  ],
  created() {},
  mounted() {},
  computed: {
    ...mapGetters("config", ["botApiUrl"]),
    ...mapState("apiAuth", ["accessToken"]),
    filesUrl() {
      return new URL(
        process.env.VUE_APP_FILES_PATH,
        this.botApiUrl || process.env.VUE_APP_API_URL
      ).toString();
    },
    memberId() {
      return this.member && this.member.id;
    },
    cardMemberParams() {
      return {
        query: {
          $eager: "[files]",
          $joinRelation: "files",
          "files.for": "profilePhoto",
        },
      };
    },
    profilePhoto() {
      return (
        this.cardMember &&
        this.cardMember.files &&
        this.cardMember.files.find((file) => file.for === "profilePhoto")
      );
    },
    addressFirstLine() {
      if (!this.member.physical_address) return null;
      return this.member.physical_address.split(",")[0];
    },
    addressTheRest() {
      if (!this.member.physical_address) return null;
      let parts = this.member.physical_address.split(",");
      parts.pop(0);
      return parts.join(", ");
    },
  },
  methods: {},
  watch: {},
  props: {
    member: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>